import React, { Component } from 'react';
import { connect } from 'react-redux';
import './forms.css';
import * as repositoryActions from '../../../Store/Actions/repositoryActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import TextBox from '../TextBox/textbox';
import Button from '../Button/button';
import ComboBox from '../ComboBox/combobox';
import { TagInput } from 'reactjs-tag-input';
import combobox from '../ComboBox/combobox';

/*
PARAMETERS :
  create : true/false
  object : {} // object to update or null if create = true,
  reservedValue : {COLUMNNAME:[ARRAY OF RESERVED VALUE]}
*/
class contactForm extends Component {
  constructor(props) {
    super(props);
    // State is in reducers
    this.state = {
      create:true,
      blankObject:{
        AC_001: 0,
        ARCS: 0,
        CODE: "",
        TYPE:"Physique",
        TAGS:"Mr,CEO",
        EMAILS:[],
        ADDRESSES:[],
        PHONES:[],
        BANKS:[],
        LINK: [],
        META: [],
        WORDING: "",
        SOCIAL_CAPITAL:"",
        FLAG: 0,
        HISTORIQUE: 0,
        IU: "",
        NSYS: 4,
        SIT: 0,
        Session: {},
        SessionIDE: "",
        Status: 0,
        
      },
      endPoint:"CTC",
    };

  }

  // BUILDING METHOD DO NOT CHANGE
  componentDidMount = () =>{
    // GET THE OBJECT IF ID is provided
    if(this.props.id > 0){
      this.props.get_single_object(this.props.sessionId,this.props.id,this.state.endPoint);
      this.setState({create:false});
    }else{
      // ELSE CREATE BLANK OBJECT AND TRIGGER ON CREATE
      this.setState({create:true});
      this.props.onCreateBlank(this.state.blankObject);
    }
  }


  // INNER METHOD 

  //GENERIC DO NOT CHANGE
  onClickCancel = () =>{
    this.props.onCancelForm();
  }

  // MAY CHANGE
  // ADD ALERT MANAGEMENT FOR UNIQUE REF
  onClickValid = () =>{
    var object = this.props.newObject;
    if(this.state.create){
      // CHECK RESERVED VALUE UNIQUE CODE
          if(this.props.dataSet.map(item=>item.CODE).includes(object.CODE)){
            alert("the value : "+object.CODE+ " should be unique and is already in use for column :"+"CODE");
          }else{
            this.props.onSave(object);
          }
    }else{
      this.props.onSave(object);
    }

  }

  //GENERIC DO NOT CHANGE
  onUpdateValue = (columnName,e) =>{
    this.props.onUpdateValue(columnName,e);
  }

  toggleType = (typeId) =>{
    console.log(" TODO contact Type",typeId);
  }

  onTagsChanged = (tags) =>{
    this.props.onUpdateValue("TAGS",tags.map(tag=>{return tag.displayValue}).join(","));
  }

  updateCompoundData = (REF,id,field,e) =>{
    var object = null;
    var objects = null;
    objects = this.props.newObject[REF];
    object = this.props.newObject[REF][id];
    object[field] =  e.target.value;
    objects[id] = object;
    this.props.onUpdateValue(REF,objects);
  }

  AddAddress = () =>{
    var data = this.props.newObject.ADDRESSES;
    data.push({TYPE:"Main",STREET:"", NUMBER:"",ZIPCODE:"",CITY:"",COUNTRY:""});
    this.props.onUpdateValue("ADDRESSES",data);
  }
  RemoveAddress = (id) =>{
    var data = this.props.newObject.ADDRESSES;
    data.splice(id,1);
    this.props.onUpdateValue("ADDRESSES",data);
  }
  buildAddresses = () =>{
    var content = null;
    if(this.props.newObject != null){
      content = this.props.newObject.ADDRESSES.map((data,id)=>{
        return <div key={id} className="compound-line">
                <input className="type" onChange={this.updateCompoundData.bind(this,"ADDRESSES",id,"TYPE")} value={data.TYPE}/>
                <input className="xl" onChange={this.updateCompoundData.bind(this,"ADDRESSES",id,"STREET")} value={data.STREET}/>
                <input onChange={this.updateCompoundData.bind(this,"ADDRESSES",id,"NUMBER")} value={data.NUMBER}/>
                <input onChange={this.updateCompoundData.bind(this,"ADDRESSES",id,"ZIPCODE")} value={data.ZIPCODE}/>
                <input onChange={this.updateCompoundData.bind(this,"ADDRESSES",id,"CITY")} className="l" value={data.CITY}/>
                <input onChange={this.updateCompoundData.bind(this,"ADDRESSES",id,"COUNTRY")} className="l" value={data.COUNTRY}/>
                <FontAwesomeIcon onClick={this.RemoveAddress.bind()} icon="trash"/>
          </div>
        ;
      });
    }
    return content;
  }
  AddEmail = () =>{
    var emails = this.props.newObject.EMAILS;
    emails.push({TYPE:"Main",EMAIL:""});
    this.props.onUpdateValue("EMAILS",emails);
  }
  RemoveEmail = (id) =>{
    var emails = this.props.newObject.EMAILS;
    emails.splice(id,1);
    this.props.onUpdateValue("EMAILS",emails);
  }
  buildEmails = () =>{
    var content = null;
    if(this.props.newObject != null){
      content = this.props.newObject.EMAILS.map((email,id)=>{
        return <div key={id} className="compound-line">
          <input className="type" onChange={this.updateCompoundData.bind(this,"EMAILS",id,"TYPE")} value={email.TYPE}/>
          <input className="xl" onChange={this.updateCompoundData.bind(this,"EMAILS",id,"EMAIL")} value={email.EMAIL}/>
          <FontAwesomeIcon onClick={this.RemoveEmail.bind(id)} icon="trash"/>
        </div>;
      });
    }
    return content;
  }

  AddPhone = () =>{
    var data = this.props.newObject.PHONES;
    data.push({TYPE:"Main",INDICATIF:"",NUMBER:""});
    this.props.onUpdateValue("PHONES",data);
  }
  RemovePhone = (id) =>{
    var data = this.props.newObject.PHONES;
    data.splice(id,1);
    this.props.onUpdateValue("PHONES",data);
  }
  buildPhones = () =>{
    var content = null;
    if(this.props.newObject != null){
      content = this.props.newObject.PHONES.map((data,id)=>{
        return <div key={id} className="compound-line">
          <input className="type" onChange={this.updateCompoundData.bind(this,"PHONES",id,"TYPE")} value={data.TYPE}/>
          <input onChange={this.updateCompoundData.bind(this,"PHONES",id,"INDICATIF")} value={data.INDICATIF}/>
          <input className="xl" onChange={this.updateCompoundData.bind(this,"PHONES",id,"NUMBER")} value={data.NUMBER}/>
          <FontAwesomeIcon onClick={this.RemovePhone.bind(id)} icon="trash"/>
        </div>;
      });
    }
    return content;
  }

  AddBank = () =>{
    var data = this.props.newObject.BANKS;
    data.push({DEVISE:"EUR",IBAN:"",BIC:"",OTHER:"",FILE:""});
    this.props.onUpdateValue("BANKS",data);
  }
  RemoveBank = (id) =>{
    var data = this.props.newObject.BANKS;
    data.splice(id,1);
    this.props.onUpdateValue("BANKS",data);
  }
  buildBanks = () =>{
    var content = null;
    if(this.props.newObject != null){
      content = this.props.newObject.BANKS.map((data,id)=>{
        return <div key={id} className="compound-line">
                <input className="type" onChange={this.updateCompoundData.bind(this,"BANKS",id,"DEVISE")} value={data.DEVISE}/>
                <input className="xl" onChange={this.updateCompoundData.bind(this,"BANKS",id,"IBAN")} value={data.IBAN} />
                <input onChange={this.updateCompoundData.bind(this,"BANKS",id,"BIC")} value={data.BIC}/>
                <input className="xl" onChange={this.updateCompoundData.bind(this,"BANKS",id,"OTHER")} value={data.OTHER}/>
                <input className="full" onChange={this.updateCompoundData.bind(this,"BANKS",id,"FILE")} value={data.FILE}/>
                <FontAwesomeIcon onClick={this.RemoveBank.bind()} icon="trash"/>
              </div>;
      });
    }
    return content;
  }

  buildLegalEntity = () =>{
    var content = null;
    if(this.props.newObject != null){
    content = <ComboBox 
    onSelectItem={this.onSelectedEntities.bind()}
    listItem={this.props.listOptions !== undefined?this.props.listOptions:[]}
    selectedItemIds={[this.props.newObject.LINKS]}
    config={
      {
        id:"ARCS",
        isSelectable:true,
        multiple:false,
        columns:[
         {name:"WORDING",type:"text"}
        ],
        actions:[]
      }
    }
    />;
    }

    return content;
  }

  onSelectedEntities = () =>{

  }

  buildContent = () =>{
    var content = null;
    var emails = this.buildEmails();
    var addresses = this.buildAddresses();
    var phones = this.buildPhones();
    var banks = this.buildBanks();
    var legalEntity = this.buildLegalEntity();

    if(this.props.newObject !== null){
      
      content = 
      <div>
        <div className="form-section">
          <div className="section-header">
            <span className="section-name">Identification (id : {this.state.create?0:0})</span>
            <div className="section-status type">
              <div className={this.props.newObject.TYPE === "Morale"?"type active":"type"} onClick={this.onUpdateValue.bind(this,"TYPE","Morale")}>Morale</div>
              <div className={this.props.newObject.TYPE === "Physique"?"type active":"type"} onClick={this.onUpdateValue.bind(this,"TYPE","Physique")}>Physique</div>
            </div>
          </div>
          <div className="section-body">
            <div className={!this.state.create ? "section-item column-1 readOnly": "section-item column-1"}>
            <label><span>Tags</span></label>
            <TagInput tags={this.props.newObject.TAGS.split(",").map((tag,id)=>{return {index:id,displayValue:tag}})} onTagsChanged={this.onTagsChanged} />
          </div>
            <div className="section-item column-2">
              <label><span>Name</span></label>
              <TextBox 
                config={
                  {
                    mask:null, 
                    color:"#999",
                    readOnly:false, 
                    maxLength:null, 
                    textAlign:"left"
                  }
                } 
                updateValue={this.onUpdateValue.bind(this,"WORDING")}
                value = {this.props.newObject !== undefined? "":""}
              />
            </div>
           
            <div className="section-item column-2">
              <label><span>{this.props.newObject.TYPE === "Physique"?"Function":"Legal Form"}</span></label>
              <TextBox 
                config={
                  {
                    mask:null, 
                    color:"#999",
                    readOnly:false, 
                    maxLength:null, 
                    textAlign:"left"
                  }
                } 
                updateValue={this.onUpdateValue.bind(this,"WORDING")}
                value = {this.props.newObject !== undefined? "":""}
              />
            </div>
            {this.props.newObject.TYPE === "Physique"?
            <div className="section-item column-1">
              <label><span>Legal Entity</span></label>
              {legalEntity}
            </div>
            :null}
          </div>
        </div>
        <div className="form-section">
          <div className="section-header">
            <span className="section-name">Contact</span>
          </div>
          <div className="section-body">
            <div className={!this.state.create ? "section-item column-1 readOnly": "section-item column-1"}>
              <label><span>Address(es)</span> <span className="clickable" onClick={this.AddAddress.bind()}>Add <FontAwesomeIcon icon="plus"/></span></label>
              {addresses}
            </div>
            <div className="section-item column-2">
              <label><span>Email(s)</span> <span className="clickable" onClick={this.AddEmail.bind()}>Add <FontAwesomeIcon icon="plus"/></span></label>
              {emails}
            </div>
            <div className="section-item column-2">
              <label><span>Phone(s)</span> <span className="clickable" onClick={this.AddPhone.bind()}>Add <FontAwesomeIcon icon="plus"/></span></label>
              {phones}
            </div>
          </div>
        </div>
        <div className="form-section">
          <div className="section-header">
            <span className="section-name">Financial</span>
          </div>
          <div className="section-body">
            <div className={!this.state.create ? "section-item column-1 readOnly": "section-item column-1"}>
              <label><span>Bank Account(s)</span> <span className="clickable" onClick={this.AddBank.bind()}>Add <FontAwesomeIcon icon="plus"/></span></label>
              {banks}
            </div>
            {this.props.newObject.TYPE === "Morale"?
            <div className="section-item column-1">
              <label><span>Social Capital</span></label>
              <TextBox 
                config={
                  {
                    mask:null, 
                    color:"#999",
                    readOnly:false, 
                    maxLength:null, 
                    textAlign:"left"
                  }
                } 
                updateValue={this.onUpdateValue.bind(this,"SOCIAL_CAPITAL")}
                value = {this.props.newObject !== undefined? "":""}
              />
            </div>
            :null}
          </div>
        </div>
        <div className="form-section">
          <div>
              <Button 
                preventMultipleClick={0} 
                config={
                  {
                    isEnabled:true,
                    icon:"check",
                    text:"save change",
                    color:null,
                    textAlign:"center",
                    bgcolor:null
                  }
                } 
                OnClickElement={this.onClickValid.bind(this)}
              />
            </div>
        </div>
      </div>;
    };
    return content;
  }

  render() {
    var content = this.buildContent();

    return (
      <div className="form-container" >
        {content}
      </div>
         
    );
  }
}

  const mapStateToProps = (state) => {    
    return {  
      newObject:state.apiReducer.newObject,
      sessionId: state.apiReducer.sessionId,
      dataSet:state.apiReducer.workingData,
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
      get_single_object: (sessionId,id,endPoint) =>dispatch(repositoryActions.get_single_object(sessionId,id,endPoint)),
      onUpdateValue:(columnName,e)=>dispatch(repositoryActions.onUpdateValue(columnName,e)),
      onCreateBlank:(object)=>dispatch(repositoryActions.onCreateBlank(object)),
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(contactForm);